<template>
  <base-modal
    title="DELETE FOLDER"
    :id="id"
    :value="value"
    extra-class="modal-sm"
    @shown="clear"
    @input="$emit('input', $event)"
  >
    <div class="row">
      <div class="col-md-12">
        <p>Are you sure you would like to delete this folder?</p>
      </div>
    </div>
    <div class="form-group">
      <label class="mt-checkbox mt-checkbox-outline">
        <input type="checkbox" :value="1" v-model="deleteFolderContent"/>
        <span></span>
        Delete existing reports and subfolders</label>
    </div>
    <template #footer>
      <button class="btn green mt-ladda-btn ladda-button remove-participant-control"
              data-dismiss="modal"
              data-style="expand-left"
              @click.prevent="deleteFolderAction({'folderId' : folderId, 'deleteFolderContent' : deleteFolderContent})">
        <span class="ladda-label">Yes</span>
      </button>
      <button class="btn default" data-dismiss="modal">Cancel</button>
    </template>
  </base-modal>
</template>

<script>
import {mapActions} from 'vuex';

import BaseModal from "../BaseModal";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    folderId: {
      required: true,
    },
  },
  data () {
    return {
      id: 'delete-folder-modal',
      name: '',
      deleteFolderContent: false,
    }
  },
  methods: {
    ...mapActions({
      deleteFolderAction: 'DELETE_FOLDER_ACTION',
    }),
    clear() {
      this.deleteFolderContent = false;
    },

  },
  components: {BaseModal},
  emits: ['save', 'input'],
}
</script>



// WEBPACK FOOTER //
// DeleteFolderModal.vue?08e9b0d7